function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "15.455"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2146",
  "data-name": "Rectangle 2146",
  fill: "#282828",
  d: "M0 0h20v15.455H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4998",
  "data-name": "Group 4998"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4985",
  "data-name": "Group 4985",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2793",
  "data-name": "Path 2793",
  d: "M18.967 3.694L15.322 7.34l-.755-.755-.754-.755 4.8-4.8L17.575 0l-4.8 4.8-1.029 1.03-1.682 1.681a2.489 2.489 0 00-.859.1 2.462 2.462 0 00-1.661 1.96 23.663 23.663 0 01-1.506 4.422H0v1.462h6.7v-.034a.961.961 0 00.2.024h.055a8.127 8.127 0 005.09-1.954 4.579 4.579 0 001.478-2.291l1.8-1.8 1.034-1.034L20 4.728zm-7.96 8.762A6 6 0 017.665 13.9a22.882 22.882 0 001.314-4.052 1 1 0 01.654-.838.987.987 0 01.294-.042 2.354 2.354 0 011.537.8c1 1 .8 1.432-.457 2.686m2.2-3.006L11.7 7.941l1.078-1.078.755.754.755.755z",
  fill: "#282828"
})))));